import React from 'react';
import { EditOutlinedIcon } from 'tuui';
import { useEntityTitle } from 'modules/campaigns/hooks/useEntityTitle';
import { ReportHeader } from '../../../../components/ReportHeader/ReportHeader';
import useCampaignHeader from '../../../../hooks/useCampaignHeader';
import useOpenCampaignEditor from '../../../../hooks/useOpenCampaignEditor';
import useOpenCampaignsGroupEditor from '../../../campaigns-group/hooks/useOpenCampaignsGroupEditor';
import campaignReportHeaderStyles from './campaignReportHeader.module.scss';

export const CampaignReportHeader = () => {
    const onEditCampaign = useOpenCampaignEditor();
    const onEditCampaignGroup = useOpenCampaignsGroupEditor();
    const onEditEntity = { onEditCampaign, onEditCampaignGroup };
    const title = useEntityTitle();
    const { shouldRenderEdit, handleEdit } = useCampaignHeader({
        onEditEntity,
    });

    return (
        <div className={campaignReportHeaderStyles['header']}>
            <ReportHeader title={title} />
            {shouldRenderEdit ? (
                <EditOutlinedIcon className={campaignReportHeaderStyles['edit-icon']} onClick={handleEdit} />
            ) : null}
        </div>
    );
};
